module.exports = __webpack_public_path__ + "img/illustration_2.d65b178a.jpg";